var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/unbound-method */
import { call, put, takeLatest } from 'redux-saga/effects';
import { actions } from '../Slice/LoginSlice';
import axios from '../Utils/Axios';
import { API } from '../Utils/Constants';
import { saveUserDetails, getCurrentTime, valueToObject, } from '../Utils/UtilityFunctions';
import { actions as flurryActions } from '../Slice/HelperSlice';
/**
 * User request/response handlera
 */
export function loginUser(dispatched) {
    var startTime, response, userInfo, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                startTime = getCurrentTime();
                _a.label = 1;
            case 1:
                _a.trys.push([1, 8, , 9]);
                return [4 /*yield*/, call(axios.post, API.LOGIN, dispatched === null || dispatched === void 0 ? void 0 : dispatched.payload)];
            case 2:
                response = _a.sent();
                if (!((response === null || response === void 0 ? void 0 : response.status) === true)) return [3 /*break*/, 5];
                userInfo = response === null || response === void 0 ? void 0 : response.response;
                return [4 /*yield*/, put(actions.loginUserLoaded(userInfo))];
            case 3:
                _a.sent();
                saveUserDetails(userInfo, dispatched.payload.rememberMe);
                return [4 /*yield*/, put(flurryActions.callFlurryEvent(valueToObject('log_in', startTime, dispatched === null || dispatched === void 0 ? void 0 : dispatched.payload)))];
            case 4:
                _a.sent();
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, put(actions.loginError(response === null || response === void 0 ? void 0 : response.message))];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [3 /*break*/, 9];
            case 8:
                err_1 = _a.sent();
                console.log(err_1);
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
export function getUserProfile(dispatched) {
    var startTime, response, userInfo, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                startTime = getCurrentTime();
                return [4 /*yield*/, put(flurryActions.callFlurryEvent(valueToObject('log_in', startTime, dispatched === null || dispatched === void 0 ? void 0 : dispatched.payload)))];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2:
                _a.trys.push([2, 6, , 7]);
                return [4 /*yield*/, call(axios.post, API.USER_PROFILE, dispatched === null || dispatched === void 0 ? void 0 : dispatched.payload)];
            case 3:
                response = _a.sent();
                if (!((response === null || response === void 0 ? void 0 : response.status) === true)) return [3 /*break*/, 5];
                userInfo = response === null || response === void 0 ? void 0 : response.response;
                return [4 /*yield*/, put(actions.loginUserLoaded(userInfo))];
            case 4:
                _a.sent();
                saveUserDetails(userInfo);
                _a.label = 5;
            case 5: return [3 /*break*/, 7];
            case 6:
                err_2 = _a.sent();
                console.log(err_2);
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
// forget password
export function forgetPassword(dispatched) {
    var startTime, response, err_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                startTime = getCurrentTime();
                _a.label = 1;
            case 1:
                _a.trys.push([1, 8, , 9]);
                return [4 /*yield*/, call(axios.post, API.FORGET_PASSWORD, dispatched === null || dispatched === void 0 ? void 0 : dispatched.payload)];
            case 2:
                response = _a.sent();
                if (!(response === null || response === void 0 ? void 0 : response.status)) return [3 /*break*/, 5];
                return [4 /*yield*/, put(actions.forgetPasswordLoaded(true))];
            case 3:
                _a.sent();
                return [4 /*yield*/, put(flurryActions.callFlurryEvent(valueToObject('forget_password_succeeded', startTime, dispatched === null || dispatched === void 0 ? void 0 : dispatched.payload)))];
            case 4:
                _a.sent();
                return [3 /*break*/, 7];
            case 5:
                if (!!(response === null || response === void 0 ? void 0 : response.status)) return [3 /*break*/, 7];
                return [4 /*yield*/, put(actions.loginError(response === null || response === void 0 ? void 0 : response.message))];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [3 /*break*/, 9];
            case 8:
                err_3 = _a.sent();
                console.log(err_3);
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
// reset password
export function resetPassword(dispatched) {
    var startTime, response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                startTime = getCurrentTime();
                _a.label = 1;
            case 1:
                _a.trys.push([1, 8, , 9]);
                return [4 /*yield*/, call(axios.post, API.RESET_PASSWORD, dispatched === null || dispatched === void 0 ? void 0 : dispatched.payload)];
            case 2:
                response = _a.sent();
                if (!(response === null || response === void 0 ? void 0 : response.status)) return [3 /*break*/, 5];
                return [4 /*yield*/, put(actions.resetPasswordLoaded(true))];
            case 3:
                _a.sent();
                return [4 /*yield*/, put(flurryActions.callFlurryEvent(valueToObject('reset_password_succeeded', startTime, dispatched === null || dispatched === void 0 ? void 0 : dispatched.payload)))];
            case 4:
                _a.sent();
                return [3 /*break*/, 7];
            case 5:
                if (!!(response === null || response === void 0 ? void 0 : response.status)) return [3 /*break*/, 7];
                return [4 /*yield*/, put(actions.resetPasswordError(response === null || response === void 0 ? void 0 : response.message))];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [3 /*break*/, 9];
            case 8:
                error_1 = _a.sent();
                console.log(error_1);
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
/**
 * Root saga manages watcher lifecycle
 */
export function userAuthSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: 
            // Watches for loadUser actions and calls getUser when one comes in.
            // By using `takeLatest` only the result of the latest API call is applied.
            // It returns task descriptor (just like fork) so we can continue execution
            // It will be cancelled automatically on component unmount
            return [4 /*yield*/, takeLatest(actions.loginUser.type, loginUser)];
            case 1:
                // Watches for loadUser actions and calls getUser when one comes in.
                // By using `takeLatest` only the result of the latest API call is applied.
                // It returns task descriptor (just like fork) so we can continue execution
                // It will be cancelled automatically on component unmount
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.forgetPassword.type, forgetPassword)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.resetPassword.type, resetPassword)];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.getUserProfile.type, getUserProfile)];
            case 4:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
